export default __webpack_public_path__ + "static/l4-dbfa06e4a240563fcdd04e8c72fcd632.png";